const Permissions = [
    { text: "Root",  name: "Root", value: 1 },
    { text: "Admin",  name: "Admin", value: 2 },
    
]

export { Permissions };